import { FaCheckCircle, FaShippingFast } from "react-icons/fa";
import { FaBox, FaClipboardCheck } from "react-icons/fa6";

const TrackingStepper = ({ status }) => {
    const statusSteps = ['Paid', 'Shipped', 'Dispatched', 'Delivered'];
    const normalizedStatus = status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    const currentStep = statusSteps.indexOf(normalizedStatus) + 1;
    const trackingSteps = [
      { label: 'Paid', icon: <FaClipboardCheck />, isCompleted: currentStep >= 1 },
      { label: 'Shipped', icon: <FaShippingFast />, isCompleted: currentStep >= 2 },
      { label: 'Dispatched', icon: <FaBox />, isCompleted: currentStep >= 3 },
      { label: 'Delivered', icon: <FaCheckCircle />, isCompleted: currentStep >= 4 },
    ];
    const isCancelled = status.toLowerCase() === 'cancelled';
  
    return isCancelled ? (
      <div className="text-center py-4 my-6 bg-red-100 text-red-600 font-semibold rounded-lg">Order has been cancelled.</div>
    ) : (
      <div className="mb-8">
        <div className="flex items-center justify-between mb-4">
          {trackingSteps.map((step, index) => (
            <div key={index} className="flex flex-col items-center">
              <div className={`flex items-center justify-center w-12 h-12 rounded-full border-4 transition-all duration-300 ${step.isCompleted ? 'border-primary bg-primary text-white' : 'border-gray-300 bg-white text-gray-500'}`}>
                {step.isCompleted ? step.icon : <span className="font-bold text-lg">{index + 1}</span>}
              </div>
              <p className={`text-sm mt-1 ${step.isCompleted ? 'text-primary font-semibold' : 'text-gray-400'}`}>{step.label}</p>
            </div>
          ))}
        </div>
        <div className="flex w-full">
          {trackingSteps.map((_, index) => (
            <div key={index} className={`flex-1 h-1 ${index < currentStep ? 'bg-primary' : 'bg-gray-300'}`}></div>
          ))}
        </div>
      </div>
    );
  };
  export default TrackingStepper